export default __webpack_public_path__ + "static/media/02.5c5884f7.jpg";